import React, { PureComponent } from 'react';
import {
    PieChart, Pie, Sector, Cell,
} from 'recharts';
import randomColour from 'randomcolor'

const data = [
    { name: 'Group A', value: 400 },
    { name: 'Group B', value: 300 },
    { name: 'Group C', value: 300 },
    { name: 'Group D', value: 200 },
];
const COLORS = ['#ffc658', '#d0ed57', '#a4de6c', '#82ca9d'];


export default class Example extends PureComponent {

    render() {


        return (
            <PieChart width={200} height={200}>
                <Pie
                    data={this.props.usersTime}
                    cx={100}
                    cy={100}
                    innerRadius={60}
                    outerRadius={90}
                    fill="#8884d8"
                    paddingAngle={2}
                    dataKey="total_minutes_worked"
                >
                    {
                        data.map((entry, index) => <Cell key={`cell-${index}`} fill={randomColour({luminosity: 'light'})} />)
                    }
                </Pie>
            </PieChart>
        );
    }
}
